module.exports = __webpack_public_path__ + "img/20191002_113546.749657cb.jpg";